import {
    SkickaEpostControllerApi,
    SkickaEpostRestVO,
} from "skickaepost-rest-api/dist/typescript-axios/api";
import { SkickaEpostRESTServiceInterface } from "./SkickaEpostRESTServiceInterface";

const BASE_PATH = "/fk_apps/SkickaEpostREST";
const api = new SkickaEpostControllerApi(undefined, BASE_PATH);

class SkickaEpostRESTServiceImpl implements SkickaEpostRESTServiceInterface {
    public async skickaEpost(
        data: SkickaEpostRestVO,
        kanal = "2",
    ): Promise<void> {
        await api.skickaEpost(kanal, data);
    }
}

export const SkickaEpostRESTService = new SkickaEpostRESTServiceImpl();
